import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.scss';
import { Tabs, Mask, Input, Toast } from 'antd-mobile-v5';
import { ApiCore } from '../../api';

let env = process.env.REACT_APP_ENV;
const api = new ApiCore();


const DoctorTools = (props: any) => {

    const [activeKey, setActiveKey] = useState('') //当前激活 tab 面板

    const [searchName, setSearchName] = useState('') //搜索工具名字

    const [navigation, setNavigation] = useState([]) //顶部锚点导航栏
    const [toolData, setToolData] = useState([]) //首页工具数据


    const [screenVisible, setScreenVisible] = useState(false) //筛选模态框
    const [screenNavigation, setScreenNavigation] = useState([]) //筛选模态框导航栏数据

    const [manageVisible, setManageVisible] = useState(false) //管理工具模态框
    const [configToolData, setConfigToolData] = useState<any>([]) //设置工具数据

    const [labels, setLabels] = useState<any>([]) //所有标签数据
    const [selectLabel, setSelectLabel] = useState([]) //选中的标签
    const [categoryCode, setCategoryCode] = useState('')


    useEffect(() => {
        localStorage.setItem('scaleTheme', 'blue')
        localStorage.setItem('source', 'doctor')


        if (window.location.search) {
            let search = window.location.search
            let url = window.location.href.replace(window.location.search, '') + search
            window.location.replace(url)
        } else {
            let homeTitle = sessionStorage.getItem('Home_Title');
            if (homeTitle) {
                document.title = homeTitle;
            }


            let selectToolLabel: any = sessionStorage.getItem('selectToolLabel')
            if (selectToolLabel) {
                setActiveKey(selectToolLabel)
                setLabels([selectToolLabel])
                getData('init', [selectToolLabel])
            } else {
                getData('init')
            }
            getLabels()
            getNavigation()
        }
    }, [])

    /**
     * 
     * @param type 是否是页面加载第一次请求 
     * @param labels 搜索的标签
     */

    const getData = (type?: string, labels?: Array<string>, name?: string) => {
        let tenantCode = localStorage.getItem('tenantCode');
        let params: any = {
            tenantCode: tenantCode,
            categoryCode: categoryCode,
            labels: labels ? labels : selectLabel,
            name: name ?? searchName
        }

        Toast.show({
            icon: 'loading',
            content: '加载中…',
            duration: 0
        })

        api.getScalePage(params).then((res: any) => {
            if (res.code === 0) {

                //如果有搜索条件就把首页工具给屏蔽掉
                if (params.categoryCode !== '' || params.labels.length > 0 || params.name !== '') {
                    let Index = res.data.data.findIndex((v: any) => v.code === 'home')
                    if (Index > -1) {
                        res.data.data.splice(Index, 1)
                        res.data.navigation.splice(Index, 1)
                    }
                }
                setNavigation(res.data.navigation)
                setToolData(res.data.data)
                Toast.clear()
            } else {
                Toast.clear()
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    const getNavigation = () => {

        let tenantCode = localStorage.getItem('tenantCode');
        let params: any = {
            tenantCode: tenantCode,
            categoryCode: '',
            labels: [],
            name: ''
        }


        api.getScalePage(params).then((res: any) => {
            if (res.code === 0) {
                console.log(res.data.navigation);
                setScreenNavigation(res.data.navigation)
            }
        })

    }

    const getLabels = () => {
        let tenantCode = localStorage.getItem('tenantCode');
        let params: any = {
            tenantCode: tenantCode
        }

        api.getDiseaseLabels(params).then((res: any) => {
            if (res.code === 0) {
                res.data.unshift({ name: '全部', code: '' })

                setLabels(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    const changeSearchName = (value: string) => {
        setSearchName(value)

        setScreenVisible(false)
        getData('', [], value)
    }

    //首页点击标签锚点
    const searchLabel = (code: string) => {
        scrollToAnchor('anchor' + code)
    }


    //改变搜索标签
    const changeLabel = (code: string) => {
        let _selectLabel: any = JSON.parse(JSON.stringify(selectLabel));
        let Index = _selectLabel.findIndex((v: any) => v === code)
        if (Index > -1) {
            _selectLabel.splice(Index, 1)
        } else {
            _selectLabel.push(code)
        }
        setSelectLabel(_selectLabel)
    }

    //改变搜索分类
    const changeCategoryCode = (code: string) => {
        setCategoryCode(code)
    }

    //重置搜索条件
    const handleRest = () => {
        setCategoryCode('')
        setSelectLabel([])
    }

    //搜索
    const handleSearch = () => {
        getData()
        setActiveKey('')
        setScreenVisible(false)
    }

    /**
     * 切换tab
     * @param {*} key 
     */
    const changeTabs = (key: string) => {
        let currentLabels = key ? [key] : []
        setActiveKey(key)
        getData('search', currentLabels)
        sessionStorage.setItem('selectToolLabel', key)
    }

    /**
     * 锚点跳转
     * @param {*} anchorName 锚点元素名称
     */
    const scrollToAnchor = (anchorName: string) => {
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView();
            }
        }
    }


    //打开设置模态框
    const openSettingToolModal = () => {
        setManageVisible(true)
        setConfigToolData(toolData)
    }

    //首页工具栏增删
    const settingTool = (parentIndex: number, item: any) => {

        let _configToolData: Array<any> = JSON.parse(JSON.stringify(configToolData));

        let scaleCodes = _configToolData[0].scaleList.map((v: any) => v.scaleCode)

        if (parentIndex === 0) {

            if (scaleCodes.length <= 1) {
                Toast.show({
                    content: '首页工具最少需要1个工具，请先增加部分工具后再删除'
                })
                return false
            }

            let Index = _configToolData[parentIndex].scaleList.findIndex((v: any) => v.scaleCode === item.scaleCode)
            _configToolData[parentIndex].scaleList.splice(Index, 1)

        } else {

            if (scaleCodes.length >= 8) {
                Toast.show({
                    content: '首页工具最多添加8个工具，请先移除部分工具后添加'
                })
                return false
            }

            let Index = _configToolData[0].scaleList.findIndex((v: any) => v.scaleCode === item.scaleCode)
            if (Index < 0) {
                _configToolData[0].scaleList.push(item)
            }
        }

        setConfigToolData(_configToolData)
    }


    //保存首页工具
    const handleSaveScale = () => {
        let data: any = configToolData[0]
        let scaleCodes = data.scaleList.map((v: any) => v.scaleCode)

        let params = {
            scaleCodes
        }
        api.saveScale(params).then((res: any) => {
            if (res.code === 0) {
                Toast.show({
                    icon: 'success',
                    content: '保存成功',
                    duration: 1000
                })
                setManageVisible(false)
                getData()
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    // 跳转工具页
    const toTool = (val: any) => {
        if (val.scaleCode.includes('DRUG') || val.scaleCode.includes('TNM')) {
            props.history.push(`/scale/aggregationScale/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        } else {
            props.history.push(`/scale/evaluation/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        }
    }


    return (
        <>
            <div className={styles.doctorTools}>
                <div id='screenContent'>
                    <div className={styles.headerContent}>
                        {labels.length > 0 && <Tabs
                            className={styles.tabsContent}
                            activeLineMode='fixed'
                            onChange={changeTabs}
                            activeKey={activeKey}
                            style={{
                                '--title-font-size': '16px',
                                '--active-line-height': '4px',
                                '--fixed-active-line-width': '20px',
                                '--active-line-color': '#fff',
                                '--active-title-color': '#fff',
                            }}>
                            {
                                labels.map((item: any) => (
                                    <Tabs.Tab title={item.name} key={item.code} >
                                    </Tabs.Tab>
                                ))
                            }
                        </Tabs>}

                        <div className={styles.searchContent}>
                            <div className={styles.search}>
                                <div className={styles.searchLeft}>
                                    <div className={styles.searchIcon}></div>
                                    <Input value={searchName} onChange={changeSearchName} className={styles.searchInput} placeholder='请输入工具名称进行搜索' clearable />
                                </div>
                                {/* <div className={styles.searchBtn} onClick={handleSearch}>搜索</div> */}
                            </div>
                        </div>

                        <div className={styles.screenContent} >
                            <div className={styles.screenLabels}>
                                {
                                    navigation && navigation.map((v: any, i: number) => (
                                        <div
                                            onClick={() => searchLabel(v.code)}
                                            className={selectLabel.findIndex((item: string) => item === v.code) > -1 ? `${styles.screenText} ${styles.active}` : styles.screenText}
                                            key={i}
                                        >
                                            {v.name}
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={styles.screenIcon} onClick={() => setScreenVisible(true)}></div>
                        </div>
                    </div>
                </div>

                <div className={styles.toolsContent}>
                    {
                        toolData.map((item: any, index: number) => (
                            <div className={styles.toolsModule} id={'anchor' + item.code} key={index}>
                                <div className={styles.moduleTitle}>
                                    <span className={styles.name}>{item.name}</span>
                                    {item.code == 'home' && <span className={styles.setting} onClick={openSettingToolModal}>设置</span>}
                                </div>
                                <div className={styles.toolList}>
                                    {
                                        item.scaleList && item.scaleList.map((v: any, i: number) => (
                                            <div className={styles.tool} key={i} onClick={() => toTool(v)}>
                                                <img src={v.icon} alt="" />
                                                <div className={styles.toolName}>{v.title}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <Mask opacity={0.45} visible={screenVisible} onMaskClick={() => setScreenVisible(false)}>
                <div className={styles.screen_content}>
                    <div className={styles.screenModule}>
                        <div className={styles.title}>病种</div>
                        <div className={styles.typeList}>
                            {
                                labels && labels.map((v: any, i: number) => (
                                    <div
                                        onClick={() => changeLabel(v.code)}
                                        className={selectLabel.findIndex((item: string) => item === v.code) > -1 ? `${styles.type} ${styles.active}` : styles.type}
                                        key={i}
                                    >
                                        {v.name}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.screenModule}>
                        <div className={styles.title}>分类</div>
                        <div className={styles.typeList}>
                            {
                                screenNavigation && screenNavigation.map((v: any, i: number) => (
                                    <div
                                        onClick={() => changeCategoryCode(v.code)}
                                        className={v.code === categoryCode ? `${styles.type} ${styles.active}` : styles.type}
                                        style={{ display: v.code === 'home' ? 'none' : 'block' }}
                                        key={i}
                                    >
                                        {v.name}
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={styles.btns}>
                        <div className={styles.btn} onClick={handleRest}>
                            重置
                        </div>
                        <div className={`${styles.btn} ${styles.success_btn}`} onClick={handleSearch}>
                            完成
                        </div>
                    </div>
                </div>
            </Mask>

            <Mask className={styles.manageModal} opacity={0.45} visible={manageVisible}>
                <div className={styles.manageTools_content}>
                    {
                        configToolData && configToolData.map((item: any, index: number) => (
                            <div className={styles.toolsModule} key={index}>
                                <div className={styles.moduleTitle}>
                                    <span className={styles.name}>{item.name}</span>
                                    {index === 0 && <div className={styles.setting}>
                                        <span className={styles.cancel} onClick={() => setManageVisible(false)}>取消</span>
                                        <span onClick={handleSaveScale}>保存</span>
                                    </div>}
                                </div>


                                <div className={styles.toolList}>
                                    {
                                        item.scaleList && item.scaleList.map((v: any, i: number) => (
                                            <div className={styles.tool} key={i}>
                                                {index === 0 && <span className={styles.minusIcon} onClick={() => settingTool(index, v)}></span>}
                                                {index !== 0 && <span
                                                    className={(configToolData[0].scaleList && configToolData[0].scaleList.findIndex((vi: any) => vi.scaleCode === v.scaleCode) < 0) ? styles.addIcon : styles.hidden}
                                                    onClick={() => settingTool(index, v)}
                                                ></span>}
                                                <img src={v.icon} alt="" />
                                                <div className={styles.toolName}>{v.title}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </Mask>
        </>
    )
}

export default DoctorTools